var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.707.293a1 1 0 0 1 .26.965l-8 30a1 1 0 0 1-1.835.238l-6.428-11.249-2.872 4.308a1 1 0 0 1-1.822-.696l1-7a1 1 0 0 1 .118-.349L.504 9.869a1 1 0 0 1 .238-1.834l30-8a1 1 0 0 1 .965.259M3.61 9.339l9.998 5.713 6.812-4.866a1 1 0 0 1 1.395 1.395l-4.866 6.812 5.713 9.998 6.928-25.98z"
})));
export default SvgSend;